/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_LoginInputs */

const vi_auth_login = /** @type {(inputs: Auth_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập`)
};

/**

* @param {Auth_LoginInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const auth_login = /** @type {((inputs?: Auth_LoginInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_LoginInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_auth_login(inputs)
});